import { snakeToCamel } from '@eventbrite/string-utils';
import { SurveyQuestion } from '../../../models/survey';
import { CheckoutState } from '../../../state';
import { getOriginalAnswersByAttendeeId } from '../getOriginalAnswersByAttendeeId';

export const getOriginalAnswersFactory = ({
    questionsForAttendee,
    questionsForBuyer,
}: {
    questionsForAttendee: Array<SurveyQuestion>;
    questionsForBuyer: Array<SurveyQuestion>;
}) => {
    const questionsByName = Object.fromEntries(
        [...questionsForBuyer, ...questionsForAttendee].map((question) => [
            question.name,
            question,
        ]),
    );

    return (state: CheckoutState) => {
        const surveyResponses = getOriginalAnswersByAttendeeId(state);

        const originalAnswers = Object.entries(surveyResponses).flatMap(
            ([attendeeId, answersByBackendQuestionName]) =>
                Object.entries(answersByBackendQuestionName).map(
                    ([backendQuestionName, answer]) => ({
                        attendeeId,
                        question:
                            questionsByName[snakeToCamel(backendQuestionName)],
                        answer,
                    }),
                ),
        );

        return originalAnswers;
    };
};
